// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Vdjc","filesListContainer":"PosDisputesFiles_filesListContainer__aXSkB","filesButton":"PosDisputesFiles_filesButton__3308K"};